import qs from 'qs';

const LICENSE_URL = '/adminApi/api/v2/system/license';
const GENERATE_CODE = '/licenseController/localAuth/v3/getApplyFile';
const UPLOAD_LICENSE = '/licenseController/localAuth/v3/uploadLicense';
const FETCH_DETAIL = '/adminApi/api/v2/system/license/paramused';

function getLicenseInfo() {
  return this.$reqGet(LICENSE_URL).then(rsp => rsp.data);
}

function getLicenseDetail(data) {
  const query = qs.stringify(data);
  return this.$reqGet(`${FETCH_DETAIL}?${query}`, data).then(rsp => rsp.data);
}

function generateCode(param) {
  return this.$reqPost(GENERATE_CODE, param).then(rsp => rsp.data);
}

function uploadLicense(file) {
  const data = new FormData();
  data.append('file', file);
  return this.$reqPost(UPLOAD_LICENSE, data).then(rsp => rsp.data);
}

export default {
  getLicenseInfo,
  getLicenseDetail,
  generateCode,
  uploadLicense,
};



// WEBPACK FOOTER //
// ./src/manage-modules/License/_api/license.js